<template>
    <div>
        <div class="col-xs-12 col-sm-6 col-md-4 agx-list-oneInRow" v-bind:style="{'background':'url('+item.thumbPath+')','height':'250px','background-size': '100% auto'}">

         
            <div>
                <div class="agx-post-tag" style="z-index:999;">
                    <span class="label label-primary" style="z-index:999;display:inline-block;">{{item.parentCategory.name}} </span> /
                    <span class="label label-info" style="z-index:999;display:inline-block;"> {{item.category.name}} </span>
                </div>
                <div class="agx-post-intros">
                    <h5>
                        <router-link :to="{name:'articleDetail',query:{postId:item.postId}}">
                            {{item.title}}
                        </router-link>
                    </h5>
                </div>
                <div class="agx-trans-layer"></div>
                <div class="col-xs-4 col-md-4">
                    <router-link :to="{name:'articleDetail',query:{postId:item.postId}}" v-if="item.thumbPath!==null">
                        <img style="display:inline-block;height:200px;border-bottom-left-radius:10px;border-bottom-right-radius:10px;"
                             class="agx-post-thumb" :src="item.thumbPath" :title="item.title">
                    </router-link>
                </div>
            </div>
           
        </div>
    </div>
</template>
<script>
    
    export default {
        components: {
            
        },
        filters: {
           
        },
        props: ["item","itemType"],
        data: function () {
            return {

            }
        },
        mounted: function () {

        }
    }
</script>